module.exports = __webpack_public_path__ + "img/comment.57215665.svg";